const defaultState = {
  origin: undefined,
  startDate: undefined,
  endDate: undefined,
  dataSource: undefined,
  annotated: undefined,
  verified: undefined,
  rejected: undefined,
  reserved: undefined,
  recognition: undefined,
  tags: undefined,
  user_id: undefined,
  multilabeling: undefined,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'FILTER_SET': {
      const {
        origin,
        startDate,
        endDate,
        dataSource,
        annotated,
        verified,
        rejected,
        reserved,
        recognition,
        tags,
        user_id,
        multilabeling,
      } = action.payload;
      return {
        ...state,
        origin,
        startDate,
        endDate,
        dataSource,
        annotated,
        verified,
        rejected,
        reserved,
        recognition,
        tags,
        user_id,
        multilabeling,
      };
    }
    default:
      return state;
  }
};
